import { instance } from '../instance';
import { getApiUrl } from '@utils';

export async function createPaymentIdeal(orderId, tipAmount) {
  const req_pay = {
    method: 'post',
    url: `${getApiUrl()}/payments/ideal`,
    headers: {
      'Content-Type': 'application/json',
    },
    data: { order: orderId, tipAmount },
  };
  const { data: response } = await instance(req_pay);

  return response;
}
